import React from 'react';
import { Collapse, Space, Typography, theme, Divider, Row, Col, List, Card } from 'antd';
import PageWrapper from '@App/components/wrappers/PageWrapper';
import { useTranslation } from 'react-i18next';

const { Panel } = Collapse;


type DataList2D = {
  title: string;
  content?: string | string[];
  texts?: string[];
  pullets?: string[];
  html?: string;
}
type GroupType = {
  title: string;
  content: string | string[];
  items:DataList2D[];
}
const informationData:GroupType[] = [
  {
    title: "Andmekaitse põhimõisted",
    content: "Selles peatükis on selgitatud peamisi isikuandmete kaitse põhimõisteid ja seda, kuidas need on seotud teadustööga. Samuti on esitatud lühiülevaade sellest, kuidas isikuandmete töötlemist õiguslikult reguleeritakse ning kuidas see on seotud teaduseetikaga.",
    items: [
      {
        title: "Mis on isikuandmete kaitse?",
        content: "Andmekaitse Tartu Ülikoolis",
        texts: [
          "sikuandmete kaitse (edaspidi ka: andmekaitse) eesmärk on kaitsta inimest ja tema eraelu. <a href=-https://eur-lex.europa.eu/legal-content/ET/TXT/?uri=celex%3A12012E%2FTXT' rel='nofollow'>Euroopa Liidu toimimise lepingus</a> ja <a href='https://eur-lex.europa.eu/legal-content/ET/TXT/?uri=CELEX:12012P/TXT' rel='nofollow'>Euroopa Liidu põhiõiguste hartas</a> sätestatakse õigus isikuandmete kaitsele iseseisva põhiõigusena, mis näitab ühemõtteliselt selle vajalikkust ja olulisust.",
          "<b>Andmekaitset</b> mõistetakse siinses juhendis kui õigusvaldkonda, mis reguleerib isikuandmete kasutamist. Ühelt poolt hõlmab see põhimõtteid, mis võivad tunduda iseenesestmõistetavad: näiteks vabatahtlikkuse põhimõte, mille kohaselt ei või küsida inimeselt tema andmete töötlemise kohta nõusolekut ähvarduste või sunniga, või inimese autonoomia austamine, mis tähendab, et igaüks peaks saama oma isikuandmete kasutamist kontrollida. Teiselt poolt põrkub isikuandmete kaitse mitme teise olulise eesmärgi ja huviga, nagu avaliku korra tagamine, teadustöö tegemine või ettevõtlus. Vastandlike huvide lahendamiseks on loodud erandeid, eeskirju ja põhimõtteid, mis ei pruugi aga enam olla endastmõistetavad.",
          
          "Selles juhendis selgitatakse erandeid, mis kehtivad isikuandmete töötlemisel teadusuuringutes. Sealjuures tuleb arvestada, et andmekaitsevaldkond on lai ning ühiskonna ja tehnoloogia arengu tõttu tekib pidevalt lahendamist vajavaid uusi küsimusi.",
          "<h3><b>Andmekaitse Tartu Ülikoolis,</b></h3> Tartu Ülikooli <a class='external-link' href='https://siseveeb.ut.ee/et/tugitegevused/delikaatsete-isikuandmete-t%C3%B6%C3%B6tlemine' rel='nofollow'>siseveebist</a> leiab lühijuhised mitmesugustel isikuandmete töötlemise teemadel. Lisaks antakse ülikoolisisesel <a>vikilehel</a> ülevaade peamistest andmekaitsepõhimõtetest valdkondade kaupa. Ülikooli töötajatele on koostatud <a class='external-link' href='https://cyberhygiene.ut.ee/' rel='nofollow'>andmekaitsemoodul</a>, mida läbides saab ennast proovile panna ja oma teadmisi täiendada. Andmekaitse üldtingimustega on võimalik tutvuda <a href='https://ut.ee/et/sisu/andmekaitsetingimused' rel='nofollow'>ülikooli veebilehel</a> ning <a class='external-link' href='https://dok.ut.ee/wd/?wdsturi=page%3Dview_dynobj%26pid=87861971' rel='nofollow'>asjaajamiseeskirja</a> IX peatükis selgitatakse ülikooli töötajate õigusi ja kohustusi isikuandmete töötlemisel. Ülikooli avalikel vikilehtedel kirjeldatakse, kuidas tegutseda <a href='https://wiki.ut.ee/pages/viewpage.action?pageId=90693746' rel='nofollow'>infoturbe</a>- ja <a href='https://wiki.ut.ee/pages/viewpage.action?pageId=116823722' rel='nofollow'>andmekaitseintsidentide</a> korral."
        ]
      },
      {
        title: "Millised on peamised isikuandmete kaitse õigusaktid?",
        texts: ["Mis muutus üldmääruse jõustumisega?"],
        html: `<div id="main-content" class="wiki-content">
        <p><span><a class="external-link" href="https://eur-lex.europa.eu/legal-content/ET/TXT/?uri=CELEX:32016R0679" rel="nofollow">Euroopa Parlamendi ja nõukogu 27. aprilli 2016. aasta määrusega (EL) 2016/679 füüsiliste isikute kaitse kohta isikuandmete töötlemisel ja selliste andmete vaba liikumise ning direktiivi 95/46/EÜ kehtetuks tunnistamise kohta</a> (lühidalt: isikuandmete kaitse üldmäärus, IKÜM; siin edaspidi: üldmäärus) on kehtestatud üldised andmekaitsepõhimõtted igat laadi isikuandmete töötlemise, sh teadusuuringute suhtes. Üldmääruse jõustumisega toimus mitu olulist muutust andmekaitse õigusnormistikus.</span></p><p><span>Esiteks on üldmäärus <strong>otsekohalduv</strong>, st see kehtib vahetult sellises sõnastuses, nagu ta kirja on pandud. Erinevalt direktiividest ei pea üldmäärust Eestis seadusega üle võtma ega seda eraldi õigusaktiga kehtestama, kuid seda tuleb täita. Lisaks on Eestis muudetud ligikaudu 130 õigusakti, et viia need üldmäärusega kooskõlla.</span></p><p><span>Üldmäärusega on Euroopa Liidu liikmesriigid kokku leppinud üldised põhimõtted, kuid see ei paku üksiklahendusi ühe või teise olukorra jaoks. Seepärast on inimeste abistamiseks kirja pandud hulk <a class="external-link" href="https://edpb.europa.eu/our-work-tools/general-guidance/guidelines-recommendations-best-practices_en" rel="nofollow">suuniseid, soovitusi ja parimaid tavasid</a>, mis aitavad üldmääruses sätestatut selgitada. Ka selle juhendi eesmärk on juhtida tähelepanu sellele, kuidas teadustöö tegemisel isikuandmete kaitsmise kohustusega arvestada.</span></p><p><span>Teiseks on igale Euroopa Liidu liikmesriigile jäetud võimalus <strong>täpsustada seadusega</strong> mõningaid olulisi <strong>erandeid</strong>. Isikuandmete töötlemine teadustöös on üks valdkondi, mida iga liikmesriik reguleerib oma seadusega. Eestis on selleks <a class="external-link" href="https://www.riigiteataja.ee/akt/104012019011?leiaKehtiv" rel="nofollow">isikuandmete kaitse seadus</a> (IKS), kus on näiteks täpsustatud eetikakomitee kooskõlastuse vajadust, mida üldmääruses ei käsitleta. Seega on isikuandmete töötlemisel teadustöös olukord tavapärasest keerulisem, kuna järgida ja tunda tuleb nii üldmäärust kui ka IKS-i.</span></p><h3 id="id-1.2.Millisedonpeamisedisikuandmetekaitseõigusaktid?-Mismuutusüldmäärusejõustumisega?"><span>Mis muutus üldmääruse jõustumisega?</span></h3><p><span>Euroopa Liidu andmekaitsereformi käigus täpsustati mitut varem kehtinud põhimõtet ja kehtestati isikuandmete töötlejatele lisanõudeid. Allpool on nimetatud mõningad olulisemad muudatused, mis puudutavad teadustöö tegemist.</span></p><p><strong><span>Muutusid terminid: </span></strong><span>senised <em>kodeerimine </em>ja <em>dekodeerimine </em>asendati <em>pseudonüümimisega</em>; termini <em>delikaatsed isikuandmed</em> asemel võeti üldmääruses kasutusele <em>isikuandmete eriliigid</em>, mis aga sõnastati<em> </em>IKS-is<em> </em>ümber <em>eriliiki</em> <em>isikuandmeteks</em>. Ka siinses juhendis kasutatakse Eesti õigusruumis levinumat terminit <em>eriliiki isikuandmeid</em>.</span></p><p><strong><span>Kaotati vastutava töötleja registreerimise nõue</span></strong><span>: varem oli Eestis süsteem, kus eriliiki isikuandmete töötlejail tuli end Andmekaitse Inspektsioonis registreerida. Sellist registreerimissüsteemi enam ei ole. Eriliiki isikuandmete nõuetekohase töötlemise tagamiseks on kehtestatud üldine tingimus pidada nõu eetikakomiteega, sobiva komitee puudumisel Andmekaitse Inspektsiooniga.</span></p><p><strong><span>Vastutava töötleja uued kohustused</span></strong><span>: Tartu Ülikoolile kui vastutavale töötlejale lisandus mitu kohustust: andmekaitsetingimuste avaldamine, isikuandmete töötlemise ülevaate koostamine, andmekaitsespetsialisti määramine, andmekaitsealaste mõjuhinnangute koostamine, järelevalveasutusega konsulteerimine ja rikkumistest teavitamine.</span></p><p><strong><span>Avalike isikuandmete töötlemine on piiratud</span></strong><span>: varem oli IKS-i alusel kehtestatud erand, mille kohaselt oli õiguspäraselt avalikustatud isikuandmete edasine töötlemine alati lubatud.<a href="#_ftn1" name="_ftnref1" rel="nofollow">[1]</a> Sellist erandit enam ei ole, mis tähendab, et ka avalikustatud isikuandmete töötlemiseks peab olema õiguslik alus, vastasel korral on töötlemine ebaseaduslik.</span></p><p><strong><span>Kehtestati trahvid</span></strong><span>: Andmekaitse Inspektsiooni volitusi laiendati õigusega määrata andmekaitserikkumiste eest trahve, mis võivad Euroopa Liidus ulatuda ettevõtete puhul kuni 4%-ni üleilmsest aastasest kogukäibest ja muude isikute puhul 20 miljoni euroni.</span></p><p><br></p><p><a href="#_ftnref1" name="_ftn1" rel="nofollow"><span>[1]</span></a> Kuni 01.01.2019 kehtinud seaduses §<span><a class="external-link" href="https://www.riigiteataja.ee/akt/106012016010#para11" rel="nofollow"> 11</a></span> lg 1. Samas hindas Riigikohus juba oma 2012. aasta otsuses <span><a class="external-link" href="https://rikos.rik.ee/?asjaNr=3-3-1-3-12" rel="nofollow">3-3-1-3-12</a></span>, et IKS-i § 11 lg 1 ei andnud iseseisvat õiguslikku alust andmete töötlemiseks. Seega ei ole tegemist põhimõttelise muutusega, vaid pigem suurenenud selgusega.</p></div>`
      },
      {
        title: "Mis on isikuandmed?",
        pullets: ["Eriliiki isikuandmed", "IP-aadressid"]
      },
      {
        title: "Mis on isikuandmete töötlemine?",
        content: "",
        texts: [""]
      },
      {
        title: "Millised on andmekaitsepõhimõtted?",
        content: "",
        pullets: [
          "Isikuandmete töötlemine on seaduslik ja õiglane",
          "Isikuandmete töötlemine on läbipaistev",
          "Isikuandmete töötlemine on eesmärgipärane",
          "Isikuandmete töötlemine on minimaalne",
          "Isikuandmete töötlemine põhineb kvaliteetsetel andmetel",
          "Isikuandmete säilitamise piirang",
          "Isikuandmete töötlemine on turvaline",
          "Lõimitud andmekaitse",
          "Vaikimisi andmekaitse",
          "Pseudonüümimine ja anonüümimine",
        ]
      },
      {
        title: "Mis on õiguslik alus?",
        content: "",
        texts: [""]
      },
      {
        title: "Kuidas on hea teadustava seotud isikuandmete töötlemisega?",
        content: "",
        texts: [""]
      }
    ]
  },
  {
    title: "Teadustöö planeerimine",
    content: "",
    items: [
      { title: "", texts: [""] }
    ]
  },
  {
    title: "Teadustöö tegemine: andmete kogumine ja analüüs",
    content: "",
    items: [
      { title: "", texts: [""] }
    ]
  },
  {
    title: "Teadustöö tulemuste avaldamine ja andmete säilitamine",
    content: "",
    items: [
      { title: "", texts: [""] }
    ]
  }
];


const count = ( indexes: number[] ): string => {
  return indexes.map( a => a + 1 ).join('.') + '. ';
}
const linkTo = (label:string, to:string, sameSite:boolean = false): JSX.Element|React.ReactNode=> (
  <a href={to} target={sameSite ? '_self' : '_blank'} ref='noopener noreferrer'>
    {label}
  </a>
)
export const FAQ: React.FC = () => {
  const { token } = theme.useToken();
  const {t, i18n} = useTranslation();

  const panelStyle = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: 'none',
  };

  return (
    <PageWrapper>
      <Typography.Title>
        {t('links.FAQ')}
      </Typography.Title>

      <Row justify='center'>
        <Col>
          <Card>
            <Typography.Paragraph>
              {
                i18n.language == 'et' || i18n.language == 'et-EE'
                  ? (
                  <>
                    Isikuandmete turvanõuete rikkumise korral helista viivitamata <a href='https://wiki.ut.ee/display/AA'>arvutiabisse</a> telefonil <a href='tel:7375500'>737 5500</a> või andmekaitse peaspetsialistile telefonil <a href='tel:7375119'>737 5119</a>.
                  </>
                  )
                  : (
                  <>In case of breach of personal data security requirements contact <a href='https://wiki.ut.ee/display/IT/Helpdesk'>IT helpdesk</a>. After working hours, please contact Senior Specialist of Data Protection (<a href='tel:+3727375119'>+372 737 5119</a>).
                  </>)
              }
            </Typography.Paragraph>      
          </Card>
        </Col>
      </Row>

      <Divider />

      <Space direction="vertical">
      {
        informationData.map( (group, groupIdx) => (
          <Collapse key={groupIdx} collapsible="header" defaultActiveKey={'Andmekaitse põhimõisted'}>
            <Panel key={group.title} header={ count([groupIdx]) + group.title } style={panelStyle}>
              
              <Typography.Paragraph>
                { group.content }
              </Typography.Paragraph>

              <Space direction="vertical">
              {
                group.items.map( (item, itemIdx) => (
                  <Collapse key={groupIdx + '-' + itemIdx} collapsible="header" bordered={false}>
                    <Panel key={itemIdx} header={ count([groupIdx, itemIdx]) + item.title}>
                      
                      { // if "content" is present and IS an array type
                        item.content && Array.isArray(item.content) && 
                        item.content.map( (text, textIdx) =>
                          <Typography.Paragraph key={textIdx}>
                            { text }
                          </Typography.Paragraph>
                        )
                      }

                      { // if "content" is present but is NOT array (must be string)
                        item.content && !Array.isArray(item.content) && (
                          <Typography.Paragraph >
                            { item.content }
                          </Typography.Paragraph>
                        )
                      }

                      { // if "texts" is present render its strings
                        item.texts && item.texts.map( (text, textIdx) =>
                          <p key={textIdx} dangerouslySetInnerHTML={{ __html: text }} />
                        )
                      }

                      { // if "pullets" is present render its strings and add pullets count 1.1.1. 
                        item.pullets && (
                          <List>
                          {
                            item.pullets.map( (text, textIdx) =>
                              <List.Item key={textIdx}>
                                { count([ groupIdx, itemIdx, textIdx ]) }{ text }
                              </List.Item>
                            )
                          }
                          </List>
                        )
                      }

                      { // if "html" is present render its strings
                        item.html && (
                          <p dangerouslySetInnerHTML={{ __html: item.html }} />
                        )
                      }

                    </Panel>
                  </Collapse>
                ))
              }
              </Space>
            </Panel>
          </Collapse>
        ))
      }
      </Space>

    </PageWrapper>
  );
}